import React from 'react';
import {observer} from 'mobx-react';
import {SdkComponent} from '../../../sdk/sdk.component';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {HeaderWelcomeButtonsContainerBox} from "./boxes/header-welcome-buttons-container.box";
import {HeaderWelcomeButtonsButtonBox} from "./boxes/header-welcome-buttons-button.box";
import {CyClass} from '../../../../../common/cy-classes';
import { Button } from '../../../../basic-ui-components/button/base/button.component';

interface SdkWelcomeComponentProps {
    marketing: string;
    showUserBadge: boolean;
    postLoginLayoutPc: string;
    styleSelectors: string;
    showRegister: boolean;
    preLoginLayoutPc?: string;
    preLoginLayoutMobile?: string;
}

@observer
export class HeaderWelcomeButtonsComponent extends OrbitComponent<{}> {

  private _getMarketingDataObject() {
    return JSON.stringify({register: "getMarketingData({\"dl\":\"19518\"})", register_in_login: "getMarketingData({\"dl\":\"19519\"})"})
  }

  private _getWelcomeStyleObj() {
    return JSON.stringify({});
  }

  _clickHandler = () => {
    if (!this.services.user.isAuthorized) {
      return;
    }
    if (!this.services.device.isMobile) {
      this.services.userMenu.closeMenu();
      return;
    }
    this.services.userMenu.openMenu();
  };

  private _renderSdkWelcomeComponent(sdkProps: SdkWelcomeComponentProps) {
    return (<SdkComponent componentId={'welcome'} className={CyClass('cy-welcome-component')} sdkProps={sdkProps} onClick={this._clickHandler}/>);
  }

  private _renderWithRegistrationButton() {

    return this._renderSdkWelcomeComponent({
        marketing: this._getMarketingDataObject(),
        showUserBadge: true,
        showRegister: true,
        postLoginLayoutPc: 'cashier',
        styleSelectors: this._getWelcomeStyleObj()
    });
  }

  private _renderWithoutRegistrationButton() {
      return this._renderSdkWelcomeComponent({
          marketing: this._getMarketingDataObject(),
          showUserBadge: true,
          showRegister: false,
          postLoginLayoutPc: 'cashier',
          styleSelectors: this._getWelcomeStyleObj(),
          preLoginLayoutPc: 'login',
          preLoginLayoutMobile: 'login'
      });
  }

  private _showRegistrationButton(): boolean {
    if(this.services.cmsSegmentation.externalBrand.isExternalBrand) {
      return false;
    }

    return this.services.configuration.data.generalSettings.showRegisterButton;
  }

  private _register = () => {
      this.services.externalLinks.openLink({source: 'membership'}, {dl: "19518"});
      this.services.analytics.sendAnalytics('Client_LoginButtons', 'Register');
  }

  private _downloadApp = () => {
    this.services.externalLinks.openDownloadApp();
    this.services.analytics.sendAnalytics('Client_LoginButtons', 'DownloadApp');
  }

  private _renderDownloadApp() {
    const showRegister = !this.services.cmsSegmentation.isCisOrCip && this.services.configuration.data.generalSettings.showRegisterButton;
    return <HeaderWelcomeButtonsButtonBox className="login_buttons cy-welcome-component">
      <Button className={CyClass("cy-get-app-button")} preset="primary" sizeVariant="small" onClick={this._downloadApp}>
        { this.services.translation.translate("GET_APP") }
      </Button>

      { showRegister ?
          <Button className={CyClass("cy-register-button")} preset="secondaryInverted" sizeVariant="small" onClick={this._register}>
            { this.services.translation.translate("SIGN_UP") }
          </Button>
        : null
      }
    </HeaderWelcomeButtonsButtonBox>;
  }
  render() {
    return (
      <HeaderWelcomeButtonsContainerBox className="cy-welcome-buttons-container">
        {
          this.services.regulation.shouldReplaceLoginWithDownloadAppForMobileWebApp() ? 
            this._renderDownloadApp() :
            (this._showRegistrationButton() ? 
              this._renderWithRegistrationButton() : 
              this._renderWithoutRegistrationButton()
            )
        }
      </HeaderWelcomeButtonsContainerBox>
    );
  }
}
